import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { State } from '../models/State';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable()
export class StatesService {
  private statesSubject = new BehaviorSubject<State[]>([]);
  private defaultState: State = new State({
    id: 2,
    state: 'Washington',
    abbr: 'WA',
    active: 1,
    created_at: '2018-10-07 00:30:19',
    updated_at: '2018-10-07 00:30:19'
  });

  constructor(private http: HttpClient) {
    this.loadStates(); // Pre-load on service init
  }

  /**
   * Returns an observable of all states.
   */
  getStates(): Observable<State[]> {
    return this.statesSubject.asObservable();
  }

  /**
   * Loads states from API and caches them.
   */
  private loadStates(): void {
    this.http.get<any[]>('state').pipe(
      map(data => data.map(d => new State(d))),
      tap(states => {
        this.statesSubject.next(states);
        const defaultMatch = states.find(s => s.state === 'Washington');
        if (defaultMatch) {
          this.defaultState = defaultMatch;
        }
      }),
      catchError(err => {
        console.error('Failed to load states:', err);
        return of([]); // return empty array on error
      })
    ).subscribe();
  }

  /**
   * Get a state by ID or return the default state.
   */
  getStateFromIdOrDefault(id: number): State {
    const states = this.statesSubject.getValue();
    const found = states.find(s => s.id === id);
    return found || this.defaultState;
  }
}
